<template>
	<template v-if="passedListingsData || passedCommandData || passedPriceStarData">
		<template v-for="(condition, conditionIndex ) in getAllConditions()" :key="condition">
			<SellerCondition
				:passed-seller="passedSeller"
				:passed-seller-index="passedSellerIndex"
				:passed-condition="condition"
				:passed-condition-index="conditionIndex"
				:passed-listings-data="passedListingsData?.[condition]"
				:passed-command-data="passedCommandData?.[condition]"
				:passed-price-star-data="passedPriceStarData?.[condition]"
				:passed-market-data="passedMarketData"
				:passed-mm-data="getMmDataForCondition(condition)"
				:passed-total-row-span="passedTotalRowSpan"
				:passed-total-seller-row-span="getTotalRowCountForSeller()"
				:passed-market-index="passedMarketIndex"
				:passed-asin="passedAsin"
				:passed-ean="passedEan"
			/>
		</template>
	</template>
</template>

<script>
import SellerCondition from "./SellerCondition.vue";
export default {
	components: {SellerCondition},
	props: {
		passedSeller: {
			type: String,
			required: true,
		},
		passedSellerIndex: {
			type: Number,
			required: true,
		},
		passedListingsData: {
			type: Object,
			required: true,
		},
		passedCommandData: {
			type: Object,
		},
		passedPriceStarData: {
			type: Object,
		},
		passedMarketData: {
			type: Object,
			required: true,
		},
		passedMmData: {
			type: Object,
		},
		passedTotalRowSpan: {
			type: Number,
			required: true,
		},
		passedMarketIndex: {
			type: Number,
			required: true,
		},
		passedAsin: {
			type: String,
			required: true,
		},
		passedEan: {
			type: String,
			required: true,
		}
	},
	methods: {
		getTotalRowCountForSeller() {
			const conditions = [1,2]
			let count = 0;
			const listingsData = this.passedListingsData;
			conditions.forEach(condition => {
				const listings = listingsData?.[condition];
				if (listings) {
					if (Array.isArray(listings)) {
						count += listings.length;
					}
				}
				const commandData = this.passedCommandData?.[condition];
				if (commandData) {
					if (Array.isArray(commandData.commands)) {
						count += commandData.commands.length;
					}
				}
				const priceStarData = this.passedPriceStarData?.[condition];
				if (priceStarData) {
					if (Array.isArray(priceStarData)) {
						count += priceStarData.length;
					}
				}
			});
			return count;
		},
		getAllConditions() {
			const listingConditions = this.passedListingsData ? Object.keys(this.passedListingsData) : [];
			const commandConditions = this.passedCommandData ? Object.keys(this.passedCommandData) : [];
			const priceStarConditions = this.passedPriceStarData ? Object.keys(this.passedPriceStarData) : [];
			return Array.from(new Set([...listingConditions, ...commandConditions, ...priceStarConditions]));
		},
		getMmDataForCondition(condition) {
			const conditionData = this.passedMmData?.[condition] || {};
			const threshold = this.passedMmData?.competitivePriceThreshold ?? null;

			return {
				...conditionData,
				competitivePriceThreshold: threshold
			};
		},
	}
}
</script>
<style scoped>
.market-cell {
	text-align: center;
	vertical-align: middle;
	font-weight: bold;
	border-right: 2px solid #ddd;
}
.vert-align{
	vertical-align: middle
}
</style>